const { document } = globalThis
const cookie_name = 'ea_importmap'
const enabled = document.cookie.indexOf(`${cookie_name}=`) !== -1
const state = enabled ? 'enabled' : 'disabled'
const state_color = enabled ? '#70ff36' : '#ff3f3f'
const domain = 'mailobj.dev'
// NOTE: Si on a un jour besoin d’avoir un host dynamique pour les environnements de dev
// const domain = window.location.hostname.split('.').slice(-2).join('.')

console.log('Importmap %c' + state, `color: ${state_color}`)

globalThis.importmap = enable => {
  let cookie = `${cookie_name}=true;path=/;domain=${domain};SameSite=lax`

  if (enable) {
    const expires = new Date()
    expires.setFullYear(expires.getFullYear() + 1)
    cookie += `;Max-Age=${expires.getTime()}`
  } else {
    cookie += ';Max-Age=-99999999'
  }

  document.cookie = cookie
}
